<template>
  <div class="mobile-nav-top">
    <div class="grid-x align-middle">
      <div class="cell small-7">
        <div class="title">
          <BackButton
            v-if="stack.length"
            tabindex="0"
            class="button-back"
            :icon-classes="{
              'chevron-large-left-black': isMcom,
              'chevron-large-left-black-custom': !isMcom,
            }"
          >
            <h5 class="padding-bottom-s padding-top-s">Back</h5>
          </BackButton>
          <div v-else>
            <span class="line1">BROWSE</span><br />
            <span class="line2" data-testid="brand-name">{{ brandName }}</span>
          </div>
        </div>
      </div>
      <div class="cell small-5 align-right search-wrapper" data-testid="search-field">
        <Search @on-input-click="triggerMainSearch" @on-keypress="triggerMainSearch" />
      </div>
    </div>
  </div>
</template>

<script setup>
/* v8 ignore file -- @preserve */
import Search from '@nuxt-common/atomic-ui/app/components/search/Search';
import BackButton from '~/components/header-mobile/BackButton.common';
import { useMobileNav } from '~/composables/useMobileNav';
import { useEventBus } from '@vueuse/core';
import { events, SEARCH } from '#shared/constants/eventBus';

const envProps = useEnvProps();

const { stack } = useMobileNav();
const isMcom = envProps.isMcom;

const brandName = isMcom ? "Macy's" : "Bloomingdale's";
const searchBus = useEventBus(SEARCH);

function triggerMainSearch() {
  searchBus.emit(events[SEARCH].OPEN);
}
</script>

<style lang="scss" scoped>
.mobile-nav-top {
  padding: 0 16px 0 20px;

  .grid-x {
    height: 71px;
  }

  .title {
    .line1 {
      font-weight: 700;
      font-size: rem-calc(12);
      line-height: rem-calc(20);
    }

    .line2 {
      font-weight: 500;
      font-size: rem-calc(18);
      line-height: rem-calc(22);
    }
  }

  .search-wrapper {
    display: flex;
    height: 71px;

    & > div {
      width: 104px;
    }
  }
}
</style>
